import Vue from 'vue'
import Router from 'vue-router'
// 0. 如果使用模块化机制编程，导入Vue和VueRouter，要调用 Vue.use(VueRouter)

// 1. 定义 (路由) 组件。
// 可以从其他文件 import 进来
Vue.use(Router)
// 2. 定义路由
import HomePage from '../views/homePage/HomePage.vue'
import NewPage from '../views/newPage/newPage.vue'
import GoodPage from '../views/goodPage/GoodPage.vue'
import LoginPage from '../views/loginPage/LoginPage.vue'
import PresetPage from '../views/presetPage/PresetPage.vue'
import BaseLayout from '../layout/BaseLayout.vue'
import TrafficPage from '../views/OldPage/TrafficPage.vue'
import ContactUs from '../views/OldPage/ContactUs.vue'
import AboutYWQ from '../views/OldPage/AboutYWQ.vue'
const router = new Router({
  // mode:'history',
  base: '/',
  routes: [{
    path: '/',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/layout',
    name: 'base-layout',
    component: BaseLayout,
    children: [
      {
        path: '/news',
        name: 'news',
        component: NewPage
      },
      {
        path: '/goods',
        name: 'goods',
        component: GoodPage,
        meta: { requiresAuth: true }
      }, {
        path: '/login',
        name: 'login',
        component: LoginPage,
      },
      {
        path: '/preset',
        name: 'preset',
        component: PresetPage
      },
      {
        path: '/other/traffic',
        name: 'traffic',
        component: TrafficPage
      }, {
        path: '/other/contact',
        name: 'contact',
        component: ContactUs
      }, {
        path: '/other/about',
        name: 'about',
        component: AboutYWQ
      }
    ]
  }
  ]
})

router.beforeEach((to, form, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // next({path:'/login'})
    next()
  } else {
    next()
  }
})


export default router
